import { OverridableComponent } from "@mui/material/OverridableComponent";
import { Topic, Category, ArrowBackIosNewRounded } from "@mui/icons-material";
import { SvgIconTypeMap } from "@mui/material";
import AcUnitIcon from '@mui/icons-material/AcUnit';

export const iconMapping: {
  [key: string]: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
} = {
  TopicIcon: Topic,
  CAT_SAMPLE: Category,
};
